import { render, staticRenderFns } from "./PropostasCliente.vue?vue&type=template&id=54a3cf5e&"
import script from "./PropostasCliente.vue?vue&type=script&lang=js&"
export * from "./PropostasCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports